import { inject, Injectable, Injector, Signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';

import { Observable } from 'rxjs';

import { resolvePostalCode as postalCodeResolver } from './postal-code.helper';
import {
	GetAddressInterface,
	PatchAddressInterface,
} from './postal-code.interface';
import { PostalCodeService } from './postal-code.service';

@Injectable()
export class PostalCodeFacade {
	private readonly postalCodeService = inject(PostalCodeService);
	private readonly injector = inject(Injector);

	resolvePostalCode(
		formGroupValueChanges$: Observable<Partial<GetAddressInterface>>,
		storeData$: Observable<GetAddressInterface>,
		patchValue: (a: PatchAddressInterface) => void,
	): Observable<GetAddressInterface> {
		return postalCodeResolver(
			formGroupValueChanges$,
			storeData$,
			300,
			(value) => patchValue(value),
			(address) => this.postalCodeService.getAddress(address),
		);
	}

	resolvePostalCodeResource(
		formGroupValueChanges: Signal<Partial<GetAddressInterface>>,
		storeData: Signal<GetAddressInterface>,
		patchValue: (a: PatchAddressInterface) => void,
	): Observable<GetAddressInterface> {
		return postalCodeResolver(
			toObservable(formGroupValueChanges, { injector: this.injector }),
			toObservable(storeData, { injector: this.injector }),
			300,
			(value) => patchValue(value),
			(address) => this.postalCodeService.getAddress(address),
		);
	}
}
